import { makeStyles } from '@mui/styles';

const options = {
  name: 'attestations-info-dialog',
};

const useStyles = makeStyles(
  () => ({
    root: {},
    iconButton: {
      cursor: 'auto',
      background: 'rgba(133, 152, 238, 0.1)',
    },
    link: {
      cursor: 'pointer',
    },
  }),
  options
);

export default useStyles;
